<template>
    <div>
        <h1>Bedankt {{userInfo.voornaam}}!</h1>
        <p>We hebben je reservering goed ontvangen!</p>
        <div class="card mt-5 mb-5">
            <div class="card-body">
                <p class="card-text">Gelieve € {{basket.value}} over te schrijven naar ons rekeningnummer: <b><u>{{bankaccount}}</u></b> op naam van <b><u>{{contactName}}</u></b></p>
            </div>
        </div>

        <router-link to="/" class="btn btn-info">-> Meer schattige foto's!</router-link>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed:{
        ...mapState(["basket", "userInfo"]),
        bankaccount(){
            return process.env.VUE_APP_BANKACCOUNT
        },
        contactName(){
            return process.env.VUE_APP_NAME
        }
    }
}
</script>
